import { Busy } from "../../components/Busy";
import { useSeasonsStore } from "../../store/seasonsStore";
import { Strong, Text } from "../../components/catalyst/text";

export const Sponsors = () => {
  const { isBusy, currentSeason } = useSeasonsStore();
  const sponsors = currentSeason?.sponsors;

  return (
    <div className="py-5">
      <div className="sm:flex sm:items-center">
        <div className="flex flex-row flex-wrap gap-2 items-center">
          <h1 className="text-base font-semibold leading-6 text-gray-900 dark:text-white">
            Sponsors
          </h1>
          <p className="text-sm text-gray-700 dark:text-gray-200">
            List of sponsors for the league who helped make it possible!!!
          </p>
        </div>
      </div>
      {!currentSeason && (
        <div className="text-center font-bold bg-gray-100 dark:bg-gray-700 p-4">
          <Text>No current season found. </Text>
        </div>
      )}

      {sponsors && sponsors.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
          {sponsors.map((sponsor) => (
            <div
              key={sponsor.id}
              className="p-4 rounded-lg shadow-sm hover:shadow-md transition-shadow bg-slate-100 dark:bg-slate-700"
            >
              <Strong className="font-bold text-lg mb-2">{sponsor.name}</Strong>
              <br />
              <Strong className=" mb-2">{sponsor.sponsorType}</Strong>
                <a
                href={sponsor.link}
                target="_blank"
                rel="noopener noreferrer"
                className="w-full h-auto bg-gray-100 dark:bg-gray-700 rounded-md block"
                >
                <img
                  src={`/api/static/images/${sponsor.logo}`}
                  alt={sponsor.name}
                  className="max-w-full object-contain dark:hidden"
                />
                <img
                  src={`/api/static/images/${sponsor.logoDark}`}
                  alt={sponsor.name}
                  className="max-w-full object-contain hidden dark:block"
                />
                </a><br />
              <a
                href={sponsor.link}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-500 hover:underline"
              >
                Visit our sponsor
              </a>
            </div>
          ))}
        </div>
      ) : (
        currentSeason && (
          <div className="text-center font-bold bg-gray-100 dark:bg-gray-700 p-4 mt-4">
            <Text>No sponsors found for the current season.</Text>
          </div>
        )
      )}

      {isBusy && <Busy busyMessage={"Please wait..."} />}
    </div>
  );
};
